"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Input = _interopRequireDefault(require("../../FormControl/Input"));

var _ComboBox = _interopRequireDefault(require("../../FormControl/ComboBox"));

var _helpers = require("../helpers");

var _gridConfig = require("../gridConfig");

var _Exports = _interopRequireDefault(require("./Exports"));

var _tKeys = require("../tKeys");

var _excluded = ["onChange"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ControlHeader = /*#__PURE__*/function (_Component) {
  _inherits(ControlHeader, _Component);

  var _super = _createSuper(ControlHeader);

  function ControlHeader() {
    var _this;

    _classCallCheck(this, ControlHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "addFilterData", function () {
      var _this$props$params = _this.props.params,
          t = _this$props$params.t,
          tKeys = _this$props$params.tKeys,
          _this$props$params$fi = _this$props$params.filter,
          onChange = _this$props$params$fi.onChange,
          rest = _objectWithoutProperties(_this$props$params$fi, _excluded);

      var filterProps = _objectSpread({
        name: 'filter',
        placeholder: t((0, _tKeys.getTKey)(tKeys, 'searchPlaceholder')),
        id: _gridConfig.FILTER_INPUT_ID,
        clearable: true,
        autoFocus: true
      }, rest);

      if (onChange) {
        filterProps.onChange = (0, _helpers.reactDebounce)(function (query) {
          return onChange({
            query: query
          });
        }, _gridConfig.ADD_FILTER_DATA_TIMEOUT);
      }

      return /*#__PURE__*/_react["default"].createElement(_Input["default"], filterProps);
    });

    _defineProperty(_assertThisInitialized(_this), "addFilterFields", function () {
      var _this$props$params2 = _this.props.params,
          t = _this$props$params2.t,
          tKeys = _this$props$params2.tKeys,
          limitFields = _this$props$params2.limitFields;
      if (!limitFields) return null;
      var data = ['all_fields'].concat(limitFields);
      return /*#__PURE__*/_react["default"].createElement(_ComboBox["default"], {
        name: "dfh",
        disabled: false,
        defaultValue: "all_fields",
        data: data,
        onChange: _this.props.filterFields,
        placeholder: t((0, _tKeys.getTKey)(tKeys, 'filterFieldsPlaceholder'))
      });
    });

    _defineProperty(_assertThisInitialized(_this), "download", function () {
      return _this.props.params.download(_this.props.selected);
    });

    _defineProperty(_assertThisInitialized(_this), "addDownload", function () {
      var _this$props = _this.props,
          selected = _this$props.selected,
          _this$props$params3 = _this$props.params,
          t = _this$props$params3.t,
          tKeys = _this$props$params3.tKeys;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('button', {
          disabled: !selected
        }),
        onClick: _this.download
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "grid-icon icon-download"
      }), t((0, _tKeys.getTKey)(tKeys, 'btnHeaderDownload')));
    });

    _defineProperty(_assertThisInitialized(_this), "addUpload", function () {
      var _this$props$params4 = _this.props.params,
          t = _this$props$params4.t,
          tKeys = _this$props$params4.tKeys;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "button"
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "grid-icon icon-upload"
      }), t((0, _tKeys.getTKey)(tKeys, 'btnHeaderUpload')), /*#__PURE__*/_react["default"].createElement("input", {
        type: "file",
        key: +new Date(),
        onChange: _this.props.params.upload
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "edit", function () {
      var _this$props2 = _this.props,
          edit = _this$props2.params.edit,
          selected = _this$props2.selected;
      typeof edit === 'function' ? edit(selected) : undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "editButton", function () {
      var _this$props3 = _this.props,
          selected = _this$props3.selected,
          _this$props3$params = _this$props3.params,
          t = _this$props3$params.t,
          tKeys = _this$props3$params.tKeys;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('button', {
          disabled: !selected || selected.notEditable
        }),
        onClick: _this.edit
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "grid-icon icon-edit"
      }), t((0, _tKeys.getTKey)(tKeys, 'btnHeaderEdit')));
    });

    _defineProperty(_assertThisInitialized(_this), "addItem", function () {
      var _this$props4 = _this.props,
          add = _this$props4.params.add,
          selected = _this$props4.selected;
      typeof add === 'function' ? add(selected) : undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "addButton", function () {
      var _this$props$params5 = _this.props.params,
          t = _this$props$params5.t,
          tKeys = _this$props$params5.tKeys;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "button",
        onClick: _this.addItem
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "grid-icon icon-plus"
      }), t((0, _tKeys.getTKey)(tKeys, 'btnHeaderAdd')));
    });

    _defineProperty(_assertThisInitialized(_this), "groupRemove", function () {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "group-remove"
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "grid-icon icon-delete"
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "getGridTitle", function () {
      var title = _this.props.params.title;
      return /*#__PURE__*/_react["default"].createElement("h6", {
        title: title,
        className: "grid-title"
      }, title);
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props5 = _this.props,
          selected = _this$props5.selected,
          params = _this$props5.params;
      var title = params.title,
          filter = params.filter,
          limitFields = params.limitFields,
          groupsRemove = params.groupsRemove,
          edit = params.edit,
          upload = params.upload,
          download = params.download,
          add = params.add,
          exports = params.exports,
          t = params.t,
          tKeys = params.tKeys,
          FilterExtensionBar = params.FilterExtensionBar,
          CustomHeader = params.GridHeader;
      if (CustomHeader) return CustomHeader(selected);
      var separator = !!groupsRemove || !!edit || !!upload || !!download || !!add;
      var exportSize = exports && Object.keys(exports).length;
      var head = !filter && !limitFields && !edit && !upload && !add && !exportSize;
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, title && head && /*#__PURE__*/_react["default"].createElement("div", {
        className: "left-settings"
      }, _this.getGridTitle()), !head && /*#__PURE__*/_react["default"].createElement("div", {
        className: "grid-header settings-container"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "left-settings"
      }, _this.getGridTitle(), filter && _this.addFilterData(), _this.addFilterFields()), /*#__PURE__*/_react["default"].createElement("div", {
        className: "right-settings"
      }, /*#__PURE__*/_react["default"].createElement(_Exports["default"], {
        exports: exports,
        t: t,
        tKeys: tKeys,
        exportSize: exportSize
      }), separator && /*#__PURE__*/_react["default"].createElement("div", {
        className: "line-separator"
      }), groupsRemove && _this.groupRemove(), edit && _this.editButton(), download && _this.addDownload(), upload && _this.addUpload(), add && _this.addButton()), FilterExtensionBar && /*#__PURE__*/_react["default"].createElement("div", {
        className: "filter-extension-bar"
      }, /*#__PURE__*/_react["default"].createElement(FilterExtensionBar, null))));
    });

    return _this;
  }

  return _createClass(ControlHeader);
}(_react.Component);

exports["default"] = ControlHeader;
ControlHeader.propTypes = {
  params: _propTypes["default"].object.isRequired,
  selected: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object])
};